const initVideoThumbnails = () => {

    const elements = document.querySelectorAll('.video-thumbnails:not(.initialised)');

    elements.forEach(element => {

        element.addEventListener('mouseenter', () => handleStartEvent(element));
        element.addEventListener('touchstart', () => handleStartEvent(element));
        element.addEventListener('mouseleave', () => handleStopEvent());
        element.classList.add('initialised');
    });
}


let runningElement; //for both video and image types
let runningTimer; //for image types

const handleStartEvent = (element) => {
    handleStopEvent();

    runningElement = element;

    const type = runningElement.getAttribute('data-type');

    if(type === 'images'){
       startImageThumbnails();
    }
    if(type === 'video'){
        startVideoThumbnail()
    }

}
const handleStopEvent = () => {
    if(runningElement){
        const type = runningElement.getAttribute('data-type');

        if(type === 'images'){
            stopImageThumbnails();
        }

        if(type === 'video'){
            stopVideoThumbnail();
        }


        runningElement = null;
    }

}

const startVideoThumbnail = () => {
    const video = runningElement.attributes['data-video'].value;
    if(!video){
        return;
    }

    const videoElement = document.createElement('video');
    videoElement.muted = true; // importantly, has to be muted for chrome; otherwise it will not autoplay
    videoElement.loop = true;
    videoElement.playsInline = true;
    videoElement.autoplay = true;
    videoElement.src = video;

    const imageElement = runningElement.querySelector('img')
    videoElement.poster = imageElement.src;

    imageElement.parentNode.appendChild(videoElement);

    const progressBar = createProgressBar()
    videoElement.parentNode.insertBefore(progressBar, videoElement.nextSibling);

    videoElement.addEventListener('loadeddata', () => {
        if (videoElement && videoElement.parentNode) { //may be already removed in stopVideoThumbnail, thats why we cheking.
            videoElement.style.opacity = '1';
            videoElement.style.visibility = 'visible';
        }
    });

    videoElement.addEventListener('timeupdate', () => {
        updateProgressBar(progressBar, videoElement.currentTime, videoElement.duration);
    });
}

const stopVideoThumbnail = () => {
    const videoElement = runningElement.querySelector('video');
    if(videoElement){
        const progressBar = videoElement.nextSibling;
        if (progressBar && progressBar.classList.contains('video-progress-bar')) {
            removeProgressBar(progressBar);
        }
        videoElement.remove();
    }
}

const startImageThumbnails = () => {
    const images = runningElement.attributes['data-images'].value.split('|');
    if(images.length === 0){
        return;
    }

    const imagesSrcset = runningElement.attributes['data-images-srcset'] ? runningElement.attributes['data-images-srcset'].value.split('|') : null;

    const imageElement = runningElement.querySelector('img')
    if(!imageElement.hasAttribute('data-original-src')){
        if(imageElement.hasAttribute('data-src')) {
            //may not be loaded yet, if image uses lazy loading
            imageElement.setAttribute('data-original-src', imageElement.getAttribute('data-src'));
        }
        else if(imageElement.src){
            imageElement.setAttribute('data-original-src', imageElement.src);
        }
    }

    if(!imageElement.hasAttribute('data-original-srcset')){
        if(imageElement.hasAttribute('data-srcset')) {
            //may not be loaded yet, if image uses lazy loading
            imageElement.setAttribute('data-original-srcset', imageElement.getAttribute('data-srcset'));
        }
        else if(imageElement.src){
            imageElement.setAttribute('data-original-srcset', imageElement.srcset);
        }
    }
    if(imagesSrcset){
        imageElement.removeAttribute('srcset'); //remove original srcset, when not provided in data-images-srcset
    }
    const progressBar = createProgressBar()
    imageElement.parentNode.insertBefore(progressBar, imageElement.nextSibling);

    let index = 0;

    index = setImageThumbnail(progressBar, imageElement, images, imagesSrcset, index);
    runningTimer = setInterval(() => {
        index = setImageThumbnail(progressBar, imageElement, images, imagesSrcset, index);
    }, 500);
}

const setImageThumbnail = (progressBar, imageElement, images, imagesSrcset, index) => {
    const totalCount = images.length - 1;
    updateProgressBar(progressBar, index, totalCount);

    imageElement.setAttribute('src', images[index]);
    if(imagesSrcset && imagesSrcset[index]){
        imageElement.setAttribute('srcset', imagesSrcset[index]);
    }
    return index === totalCount ? 0 : index + 1;
}

const stopImageThumbnails = () => {
    if(runningTimer){
        clearInterval(runningTimer);
        runningTimer = null;
    }
    const imageElement = runningElement.querySelector('img')
    if(imageElement.getAttribute('data-original-src')){
        imageElement.setAttribute('src', imageElement.getAttribute('data-original-src'));
        imageElement.removeAttribute('data-original-src');
    }
    if(imageElement.getAttribute('data-original-srcset')){
        imageElement.setAttribute('srcset', imageElement.getAttribute('data-original-srcset'));
        imageElement.removeAttribute('data-original-srcset');
    }
    const progressBar = imageElement.nextSibling;
    if (progressBar && progressBar.classList.contains('video-progress-bar')) {
        removeProgressBar(progressBar);
    }
}

const createProgressBar = () => {
    const progressBar = document.createElement('div');
    progressBar.classList.add('video-progress-bar');
    return progressBar;
}
const updateProgressBar = (progressBar, step, stepsCount) => {
    progressBar.style.width = `${(step / stepsCount) * 100}%`;
}
const removeProgressBar = (progressBar) => {
    progressBar.remove();
}

export default initVideoThumbnails;